import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useContext } from "@nuxtjs/composition-api";
import { until } from "@vueuse/shared";
import { useContactStore } from "~/composables/useContactDialog";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const {
  visibleList,
  list,
  isLoadingList,

  visibleExclusive,
  // isReadyList,
  // fetchList
} = useContactStore();

const onOpen = (item: typeof list.value[number]) => {
  checkedState.value.push(item.open_kfid);
};

const onClose = (item: typeof list.value[number]) => {
  checkedState.value = checkedState.value.filter((id) => id !== item.open_kfid);
};

const checkedState = ref<string[]>([]);

const onOpenList = () => {
  visibleList.value = true;
  visibleExclusive.value = false;
};

const { store } = useContext();
const kfQrcode = computed(() => {
  return store.getters.userInfo?.sales_wechat_card;
});
// export default defineComponent({
//   name: "ContractDialog",
//   setup() {

//     return {
//       visibleList,
//       list,
//       // popoverOptions,

//       checkedState,
//       onOpen,
//       onClose,

//       visibleExclusive
//     };
//   },
//   // setup() {
//   //     const { isRevealed, cancel } = useContactStore()
//   //     return {
//   //         isRevealed,
//   //         cancel
//   //     }
//   // },
//   //   data() {
//   //     return {
//   //       // visible: true,
//   //       rules: {
//   //         name: [
//   //           { required: true, message: "请填写联系人姓名", trigger: "blur" },
//   //         ],
//   //         mobile: [
//   //           { required: true, message: "请输入手机号", trigger: "blur" },
//   //           {
//   //             pattern: /^1[3456789]\d{9}$/,
//   //             message: "手机号格式不对",
//   //             trigger: "blur",
//   //           },
//   //         ],
//   //       },
//   //       form: {
//   //         name: "",
//   //         mobile: "",
//   //         message: "",
//   //       },
//   //     };
//   //   },
//   //   methods: {
//   //     async saveContact() {
//   //       this.$refs.refContact.validate(async (valid) => {
//   //         if (valid) {
//   //           const { code, msg } = await homeSaveContact(this.form);
//   //           if (code !== REQUEST_CODES.ERROR_OK) return this.$message.error(msg);

//   //           this.$message.success("提交成功");
//   //           this.$refs.refContact.resetFields();
//   //         }
//   //       });
//   //     },
//   //   },
// });

return { __sfc: true,visibleList, list, isLoadingList, visibleExclusive, onOpen, onClose, checkedState, onOpenList, store, kfQrcode }
}

})